import React, {useEffect} from "react";
import {inject, observer} from "mobx-react";
import {Route, Switch} from "react-router-dom";
import Component from "../Components";

function History(props) {

    useEffect(() => {

        
        const fetchData = async () => {
            await props.Data.getByStatus(`all`);
        }

        fetchData();

    }, [props.Data]);
    
    useEffect(() => {
        document.title = `Historia`
    }, [props]);
    
    return (
        <>

            <h1>Historia</h1>
            <p className="text-muted">Widok zrealizowanych zamówień</p>

            <Component.Card.List title="Zrealizowane zamówienia" class="all"/>

            <Switch>
                <Route path="/order/:id">
                    <Component.Card.Bar/>
                </Route>
            </Switch>
        </>
    );
}

export default inject('Data')(observer(History))
